import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AWS from 'aws-sdk';
import SummaryApi from '../common/index';
import { toast } from 'react-toastify';

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

const CreateYatra = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    yatraName: '',
    startDate: '',
    durationInDays: '',
    visitingPlaces: '',
    pricePerPerson: '',
    bookamount: '',
    rulesAndGuidelines: '',
    status: 'upcoming',
    departureLocation: '',
  });

  const [images, setImages] = useState([]);
  const [dayPlan, setDayPlan] = useState({ day: 1, title: '', description: '' });
  const [itineraryList, setItineraryList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImages([...e.target.files]);
  };

  const uploadImageToS3 = async (file) => {
    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      Key: `yatra_photos/${Date.now()}_${file.name}`,
      Body: file,
      ContentType: file.type,
    };

    return new Promise((resolve, reject) => {
      s3.upload(params, (err, data) => {
        if (err) reject(err);
        else resolve(data.Location);
      });
    });
  };

  const validateForm = () => {
    const { yatraName, startDate, durationInDays, visitingPlaces, pricePerPerson, bookamount, } = formData;
    return yatraName && startDate && durationInDays && visitingPlaces && pricePerPerson && bookamount ;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error('कृपया सर्व आवश्यक फील्ड भरावेत');
      return;
    }

    try {
      const imageUploadPromises = images.map(uploadImageToS3);
      const uploadedImageUrls = await Promise.all(imageUploadPromises);

      const payload = {
        ...formData,
        itinerary: itineraryList,
        images: uploadedImageUrls,
      };

      const res = await fetch(SummaryApi.createYatra.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (res.ok) {
        toast.success('यात्रा यशस्वीरित्या तयार झाली');
        setFormData({
          yatraName: '',
          startDate: '',
          durationInDays: '',
          visitingPlaces: '',
          pricePerPerson: '',
          bookamount: '',
          rulesAndGuidelines: '',
          status: 'upcoming',
          departureLocation: '',
        });
        setImages([]);
        setDayPlan({ day: 1, title: '', description: '' });
        setItineraryList([]);
        navigate('/');
      } else {
        toast.error(result.message || 'Failed to create yatra');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error while creating yatra');
    }
  };

  const addDayToItinerary = () => {
    if (dayPlan.title && dayPlan.description) {
      setItineraryList([...itineraryList, dayPlan]);
      setDayPlan({ day: dayPlan.day + 1, title: '', description: '' });
    } else {
      toast.warn('कृपया दिवसाचे शीर्षक आणि वर्णन भरा');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded mt-6">
      <h1 className="text-2xl font-bold text-orange-700 mb-6">🛕 नवीन यात्रा फॉर्म</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid md:grid-cols-2 gap-4">
          {[
            { label: 'यात्रेचे नाव', name: 'yatraName', type: 'text' },
            { label: 'प्रारंभ तारीख', name: 'startDate', type: 'date' },
            { label: 'एकूण दिवस', name: 'durationInDays', type: 'number' },
            { label: 'स्थळे ([स्थान1,स्थान2])', name: 'visitingPlaces', type: 'text' },
            { label: 'प्रति व्यक्ती खर्च', name: 'pricePerPerson', type: 'number' },
            { label: 'अॅडव्हान्स', name: 'bookamount', type: 'number' },
            { label: 'सुरुवातीचे ठिकाण', name: 'departureLocation', type: 'text' },
          ].map((field, idx) => (
            <div key={idx}>
              <label className="block text-sm font-medium mb-1">{field.label}</label>
              <input
                type={field.type}
                name={field.name}
                value={formData[field.name]}
                onWheel={(e) => e.target.blur()}
                className="w-full border px-3 py-2 rounded"
                onChange={handleChange}
                required
              />
            </div>
          ))}

          <div>
            <label className="block text-sm font-medium mb-1">नियम व मार्गदर्शक तत्त्वे</label>
            <textarea
              name="rulesAndGuidelines"
              className="w-full border px-3 py-2 rounded"
              value={formData.rulesAndGuidelines}
              onChange={handleChange}
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">स्थिती</label>
            <select
              name="status"
              className="w-full border px-3 py-2 rounded"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="upcoming">Upcoming</option>
              <option value="past">Past</option>
            </select>
          </div>
        </div>

        {/* Day-wise itinerary section */}
        <div className="border p-4 rounded-md bg-orange-50">
          <h2 className="text-lg font-semibold text-orange-700 mb-4">दैनंदिन कार्यक्रम</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <input
              type="number"
              value={dayPlan.day}
              onWheel={(e) => e.target.blur()}
              readOnly
              className="w-full border px-3 py-2 bg-gray-100"
            />
            <input
              type="text"
              placeholder="शीर्षक"
              value={dayPlan.title}
              onChange={(e) => setDayPlan({ ...dayPlan, title: e.target.value })}
              className="w-full border px-3 py-2"
            />
            <input
              type="text"
              placeholder="वर्णन"
              value={dayPlan.description}
              onChange={(e) => setDayPlan({ ...dayPlan, description: e.target.value })}
              className="w-full border px-3 py-2"
            />
          </div>
          <button
            type="button"
            onClick={addDayToItinerary}
            className="bg-orange-600 text-white px-6 py-2 mt-4 rounded hover:bg-orange-700"
          >
            दिवस {dayPlan.day} साठवा आणि पुढे जा
          </button>

          {itineraryList.length > 0 && (
            <ul className="mt-4 list-disc list-inside text-sm text-gray-800 space-y-1">
              {itineraryList.map((item, idx) => (
                <li key={idx}>
                  <strong>दिवस {item.day}:</strong> {item.title} - {item.description}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Image Upload */}
        <div>
          <label className="block text-sm font-medium mb-1">फोटो अपलोड करा</label>
          <input
            type="file"
            multiple
            accept="image/*"
            className="w-full border px-3 py-2 rounded"
            onChange={handleFileChange}
          />
        </div>

        <button type="submit" className="bg-orange-600 text-white px-6 py-2 rounded hover:bg-orange-700 w-full">
          यात्रा तयार करा
        </button>
      </form>
    </div>
  );
};

export default CreateYatra;
